import { divisionFormatTypeIds } from '../../../../../utils/eventConstants';
import { getInvitedByPlayer, getInvitedByPlayerName } from '../../../../../utils/events';

export const InvitationTypes = {
    PLAYER_INVITATION: 1,
    ADMIN_ADD: 2,
    PRE_REGISTRATION: 3,
};

export const shouldDisplayPartner = (division, type) => {
    if (type === InvitationTypes.ADMIN_ADD) {
        if (division?.divisionFormatTypeId === divisionFormatTypeIds.SINGLES) {
            return false;
        }

        return division?.partner != null;
    }

    return false;
};

export const getInvitationObjectFromDivision = (division, type) => {
    return {
        id: `${type}-${division.id}`,
        divisionId: division.id,
        name: division.name,
        type,
        data: {
            ...division,
        },
        inviteeName: type === InvitationTypes.PLAYER_INVITATION
            ? getInvitedByPlayerName(division)
            : 'Event provider',
        inviteeId: type === InvitationTypes.PLAYER_INVITATION
            ? getInvitedByPlayer(division)?.id
            : null,
        shouldDisplayPartner: shouldDisplayPartner(division, type),
        partnerName: getInvitedByPlayerName(division),
        partnerId: getInvitedByPlayer(division)?.id,
    };
};

export const getInvitationObjectFromPreRegInvite = (preRegInvite) => {
    return {
        id: `${InvitationTypes.PRE_REGISTRATION}-${preRegInvite.preRegistrationInviteId}`,
        name: preRegInvite.divisionCategoryName,
        type: InvitationTypes.PRE_REGISTRATION,
        data: {
            ...preRegInvite,
        },
        inviteeName: 'Event provider',
        inviteeId: null,
    };
};
